import localForage from 'localforage';
import store from '../store';
import { of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { APP_CONFIG } from '@/config';

/** 本地数据库枚举字段key */
enum LsKey {
  userData = 'userData',
}

interface UserData {
  videoId: string;
  name: string;
  posters?: any[];
}

/** 本地缓存服务 */
class LsService {
  localForage = localForage;

  constructor() {
    (window as any).localForage = this.localForage;
    // 本地数据库初始化配置
    this.localForage.config({
      // driver: localForage.INDEXEDDB, // Force WebSQL; same as using setDriver()
      name: `FNW-${APP_CONFIG.siteName}-${APP_CONFIG.version}`,
      version: 1.2,
      // size: 4980736, // Size of database, in bytes. WebSQL-only for now.
      // storeName: 'keyvaluepairs', // Should be alphanumeric, with underscores.
      // description: 'some description',
    });
  }

  saveUserData(data: UserData) {
    console.log('saveUserData', data);
    localForage.setItem(LsKey.userData, data);
  }

  getUserData() {
    return of(0).pipe(
      switchMap(() => localForage.getItem(LsKey.userData)),
      tap((res: any) => {
        if (!res) return;
        const data: UserData = res || {};
        if (!data.videoId) return;
      }),
    );
  }

  removeUserData() {
    localForage.removeItem(LsKey.userData);
    console.log('remove userData');
  }
}

/** 单例对象函数 */
const service = (() => {
  // 隐藏的Class的构造函数
  // function TodayCilpService() {}

  // 未初始化的单例对象
  let service: LsService;

  return {
    // 创建/获取单例对象的函数
    getInstance: () => {
      if (!service) {
        service = new LsService();
      }
      return service;
    },
  };
})();
export const lsService = service.getInstance();
